<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import Invoices from "../dashboard-customer/invoices";
import StatementAccount from "../dashboard-customer/statement-of-account-listing";
import CreditNotes from "../dashboard-customer/credit-notes";
import AgingReport from "../dashboard-customer/aging-report";
import Tab from "@/components/ar/Tab";
import CollectionDetail from "@/components/ar/collection-detail";
import Stat from "@/components/ar/stat";
import moment from 'moment';
import axios from 'axios';
import { usePermissions } from '@/composables/usePermissions';

//import Widgets from "./widget.vue";

export default {
  
  page: {
    title: "Customer Dashboards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Customer Information",
      items: [
        {
          text: "Customer",
          href: "/",
        },
        {
          text: "Customer Information",
          href: "customer-details/"+this.$route.params.id,
        },
        {
            text: "Customer Information",
            href: "customer-details/"+this.$route.params.id+"/ar",
            active: true,
        }
      ],
      Collection:[],
      outstanding_amount:'',
      late_payment:'',
      unresolved_invoice:'',
      nameperic:'',
      order_id:'',
    }
  },
  setup() {
        const {
            canReadCustomers,
            canReadInvoices,
            canReadAgingReport,
            arPermissions
        } = usePermissions()
        return {
            canReadCustomers,
            canReadInvoices,
            canReadAgingReport,
            arPermissions
        };
    },
  methods:{
    format_date(value){
      if (value) {
          return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
      }
    },

    get_customer_by_id(){
        this.showAr = localStorage.getItem('showAr');
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_AR_API_BASEURL+'customer/'+this.$route.params.id)
        .then(response => {
            if (response) {
                this.nameperic = response.data.name_as_per_nric;
                this.order_id = response.data.order.orderId;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },
    

    GetCollectionData(cust_id){
      
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_AR_API_BASEURL+'dashboard/customer/collection/'+cust_id)
        .then(response => {
            if (response) {
                this.Collection=response.data;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

  },
  components: {
    Layout,
    PageHeader,
    // Widgets,
    Invoices,
    AgingReport,
    CreditNotes,
    StatementAccount,
    Tab,
    CollectionDetail,
    Stat,
  },
  mounted() {
    this.GetCollectionData(this.$route.params.id);
    this.get_customer_by_id();
  }

  
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header border-0">
                        <div class="d-flex align-items-center">
                        <h3><i class="ri-function-fill text-muted align-bottom me-1"></i>{{ nameperic }}</h3>
                        </div>
                        <!--end row-->
                    </div>
                    <div>
                        <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
                            <li class="nav-item">
                                <router-link :to="'/customer/customer-details/'+this.$route.params.id" class="nav-link" aria-selected="true" >
                                    <i class="ri-information-line text-muted align-bottom me-1"></i>
                                    Summary
                                </router-link>
                            </li>
                            <li class="nav-item">


                                <router-link :to="'/customer/customer-details/'+this.$route.params.id" class="nav-link " aria-selected="true" >
                                    <i class="ri-shopping-cart-2-line text-muted align-bottom me-1"></i>
                                    Orders
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="'/customer/customer-details/'+this.$route.params.id" class="nav-link " aria-selected="true" >
                                    <i class="ri-file-edit-line text-muted align-bottom me-1"></i>
                                    Contracts
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="'/customer/customer-details/'+this.$route.params.id" class="nav-link " aria-selected="true" >
                                    <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
                                    Customer Checks
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar'" class="nav-link active" aria-selected="true" >
                                    <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
                                    AR
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="row project-wrapper">
                        <div class="col-xxl-12 mb-5">
                            <Stat :cust_id="$route.params.id" :order_id="order_id"/>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card">
                            <div class="border-0">
                                <div class="d-flex align-items-center">
                                
                                </div>
                                <!--end row-->
                            </div>
                            <div>
                                <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
                                
                                    <Tab typr="collection"/>
                                </ul>
                            </div>
                            <div class="card-body p-4">
                                <div class="tab-content text-muted">
                                    <CollectionDetail :cust_id="$route.params.id"/>

                                <!--contracts tab-pane-->
                                <div class="tab-pane" id="invoices" role="tabpanel" >
                                    <Invoices :invoicelistall="invoicelist"/>
                                </div>
                                <div class="tab-pane" id="creditnotes" role="tabpanel">
                                    <CreditNotes/>
                                </div>
                                <!--customer checks tab-pane-->
                                <div class="tab-pane" id="soa" role="tabpanel">
                                    <StatementAccount/>
                                </div>
                                <div class="tab-pane" id="agingreport" role="tabpanel">
                                    <AgingReport/>
                                </div>
                                <!--end tab-pane-->
                                </div>
                                <!--end tab-content-->
                            </div>
                            <!--end card-body-->
                            </div>
                            <!--end card -->
                        </div>
                        <!--end card -->
                    </div>
                </div>
            </div>
        </div>

        

    </Layout>
</template>